<template>
  <page-section title="Outils pédagogiques">
    <alert type="warning">
      <p class="text-center">
        <strong>
          Les documents présents sur cette page sont en accord avec les
          recommandations nationales en vigueur.
        </strong>
      </p>
    </alert>
    <lily-component :contents="lily.cvp"
                    :open="initialCollapse.cvp" id="cvp">
    </lily-component>
    <lily-component :contents="lily.valve"
                    :open="initialCollapse.valve" id="valve">
    </lily-component>
    <lily-component :contents="lily.cleanhand4"
                    :open="initialCollapse.cleanhand4" id="cleanhand4">
    </lily-component>
    <lily-component :contents="lily.gloves"
                    :open="initialCollapse.gloves" id="gloves">
    </lily-component>
    <lily-component :contents="lily.outfit"
                    :open="initialCollapse.outfit" id="outfit">
    </lily-component>
    <lily-component :contents="lily.cleanhandprox"
                    :open="initialCollapse.cleanhandprox" id="cleanhandprox">
    </lily-component>
    <lily-component :contents="lily.midline"
                    :open="initialCollapse.midline" id="midline">
    </lily-component>
  </page-section>
</template>
<script>
import cardFill from '@/components/cards/cardFill'
import lilyComponent from '@/components/tools/lily'
import pageSection from '@/components/pagesection'
import videoFrame from '@/components/videoFrame'
import lily from '@/sc/lily'

export default {
  name: 'educational',

  computed: {
    lily: function () {
      return lily
    },

    initialCollapse: function () {
      const result = {
        cvp: false,
        valve: false,
        cleanhand4: false,
        gloves: false,
        outfit: false,
        cleanhandprox: false,
        midline: false
      }
      const tab = this.$route.query.collapse
      if (tab == null) {
        return result
      }

      result[tab] = true
      return result
    }
  },

  mounted: function () {
    const vm = this
    setTimeout(
      () => {
        const tab = vm.$route.query.collapse
        if (tab != null) {
          const element = vm.$el.querySelector(`#${tab}`)
          if (element != null) {
            const top = element.offsetTop
            window.scrollTo(0, top - 20)
          }
        }
      },
      100
    )
  },

  components: {
    'video-frame': videoFrame,
    'card-fill': cardFill,
    'page-section': pageSection,
    'lily-component': lilyComponent
  }

}
</script>
<style lang="less" scoped>
</style>
